import { Injectable } from '@angular/core';
import { FBP_EVENTS, FBP_TACK_TYPES } from '@core-constants/fbp-tracking.const';
import { IPixelContentsDataModel, PixelAddToCartDataModel, PixelInitiateCheckoutDataModel, PixelPurchaseDataModel } from '@core-models/pixel.model';
import { PurchaseConst } from '@core-constants/purchase.const';
import { ShoppingCartPlusItem } from '@core-models/shopping-cart-plus.model';

declare let fbq: any;

@Injectable({
  providedIn: 'root'
})
export class PixelService
{
  constructor() { }

  public trackAddToCartEvent(data: PixelAddToCartDataModel = null): void
  {
    if (fbq)
    {
      fbq(FBP_TACK_TYPES.TRACK, FBP_EVENTS.ADD_TO_CART, data);
    }
  }

  public trackPurchaseEvent(data: PixelPurchaseDataModel = null): void
  {
    if (fbq)
    {
      fbq(FBP_TACK_TYPES.TRACK, FBP_EVENTS.PURCHASE, data);
    }
  }

  public tackInitiateCheckoutEvent(data: PixelInitiateCheckoutDataModel = null): void
  {
    if (fbq)
    {
      fbq(FBP_TACK_TYPES.TRACK, FBP_EVENTS.INITIATE_CHECKOUT, data);
    }
  }

  public buildPixelAnalyticsProductList(cartItems: ShoppingCartPlusItem[]): IPixelContentsDataModel[]
  {
    const products: IPixelContentsDataModel[] = [];

    cartItems.forEach(element =>
    {
      if (element)
      {
        products.push({
          id: element.name,
          quantity: element.quantity,
          item_price: element.rate.finalAmount,
          type: element.status === 0 ? PurchaseConst.PurchaseTypes.Acquisition : PurchaseConst.PurchaseTypes.Others,
          location: element.location
        });
      }
    });

    return products;
  }
}
